var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9967 9.93814H16.5841C16.2916 9.93814 16.0544 10.1753 16.0544 10.4678V16.908C16.0544 17.2499 15.7762 17.528 15.4344 17.528H3.09172C2.74995 17.528 2.47196 17.2499 2.47196 16.908V4.56568C2.47196 4.22378 2.74995 3.94558 3.09172 3.94558H9.86171C10.1542 3.94558 10.3914 3.70841 10.3914 3.41588V2.00334C10.3914 1.7108 10.1542 1.47363 9.86171 1.47363H3.09172C1.38691 1.47363 0 2.86075 0 4.56568V16.9081C0 18.613 1.38698 20 3.09172 20H15.4343C17.1392 20 18.5263 18.613 18.5263 16.9081V10.4679C18.5264 10.1753 18.2892 9.93814 17.9967 9.93814Z",
    fill: "#9DA0E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.4703 0H13.8517C13.5591 0 13.322 0.237165 13.322 0.529702V1.94224C13.322 2.23478 13.5591 2.47194 13.8517 2.47194H15.7801L8.52347 9.72837C8.3166 9.93524 8.3166 10.2706 8.52347 10.4775L9.52228 11.4764C9.62165 11.5758 9.75634 11.6316 9.89689 11.6316C10.0374 11.6316 10.1721 11.5758 10.2714 11.4764L17.528 4.21982V6.14815C17.528 6.44069 17.7652 6.67785 18.0577 6.67785H19.4703C19.7628 6.67785 20 6.44069 20 6.14815V0.529702C20 0.237165 19.7628 0 19.4703 0Z",
    fill: "#9DA0E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a5a6cfec.svg";
export { ForwardRef as ReactComponent };